import { navigation } from '../app/navigation.js';
import { AccountPanelBase } from './account_panel_base.js';

/**
 * Login panel.
 */
class LoginPanel extends AccountPanelBase {
  static id = 'login';

  initialize() {
    super.initialize();
    this.setLoginListeners();
  }

  static markup = `
    <div class='spacer'></div>
    <div class='msg' hidden></div>
    <h1>Your <span class='designation'>CamperAid</span></h1>
    <form class='default' method='post'>
      <input placeholder='email' type='email' autocomplete='username' required><br>
      <input placeholder='password' type='password' autocomplete='current-password'
             required><br>
      <button type='submit'>Log in</button>
    </form>

    <span class='note'>If no account yet, please
      <a class='signup-link' href='/signup'>sign up</a>.
    </span>
    <div class='spacer-3'></div>
  `;

  get historyState() {
    return [
      { page: this.page },
      `CamperAid - Log in`,
      `${window.location.origin}/login`,
    ];
  }

  switchOn() {
    document.body.setAttribute('signup-login-page', 'true');

    const { email, recoverPwd, timeout } = navigation.params;
    if (timeout) {
      this.msgBox.error(
        `The session has been expired. Please re-enter the credentials to continue.`
      );
    }
    if (email) {
      this.emailElement.value = email;
    }

    if (recoverPwd) {
      this.recover(email);
      return;
    }

    super.switchOn();
    this.emailElement.focus();
  }

  switchOff() {
    super.switchOff();
    document.body.removeAttribute('signup-login-page');
  }
}

navigation.registerPanel(LoginPanel);

export { LoginPanel };
